var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13001 4.21001H3.15001C2.79655 4.21001 2.51001 4.49654 2.51001 4.85001V13.43C2.51001 13.7835 2.79655 14.07 3.15001 14.07H4.13001C4.48347 14.07 4.77001 13.7835 4.77001 13.43V4.85001C4.77001 4.49654 4.48347 4.21001 4.13001 4.21001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60002 10.26H4.77002V8.02H8.70002V8.84",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.87 14.08H20.85C21.2035 14.08 21.49 13.7935 21.49 13.44V4.86C21.49 4.50654 21.2035 4.22 20.85 4.22H19.87C19.5165 4.22 19.23 4.50654 19.23 4.86V13.44C19.23 13.7935 19.5165 14.08 19.87 14.08Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 10.26H19.2299V8.02H16.2",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2001 19.79V7.41",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70003 8.99001C8.13003 8.99001 7.66003 9.45001 7.66003 10.03V11.84C7.66003 12.43 7.90003 13 8.31003 13.42L9.41003 14.52C9.83003 14.94 10.4 15.17 10.99 15.17V19.8",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.26 14.08C13.26 12.87 12.28 11.89 11.07 11.89H9.65002V10.48H9.92002C10.25 10.48 10.55 10.33 10.75 10.09",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64008 6.34001C10.1601 6.34001 10.5801 6.76001 10.5801 7.28001V8.99001H8.71008V7.28001C8.71008 6.76001 9.13008 6.34001 9.65008 6.34001H9.64008Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5101 5.57001C12.0301 5.57001 12.4501 5.99001 12.4501 6.51001V9.55001C12.4501 10.07 12.0301 10.49 11.5101 10.49C11.2001 10.49 10.9201 10.34 10.7601 10.1C10.9101 9.92001 11.0001 9.68001 11.0001 9.42001C11.0001 9.18001 10.8101 8.99001 10.5701 8.99001V6.51001C10.5701 5.99001 10.9901 5.57001 11.5101 5.57001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4501 6.51001V9.54001C12.4501 10.0592 12.8687 10.48 13.3851 10.48C13.9015 10.48 14.3201 10.0592 14.3201 9.54001V6.51001C14.3201 5.99086 13.9015 5.57001 13.3851 5.57001C12.8687 5.57001 12.4501 5.99086 12.4501 6.51001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3201 7.28001V9.54001C14.3201 10.0592 14.7387 10.48 15.2551 10.48C15.7715 10.48 16.1901 10.0592 16.1901 9.54001V7.28001C16.1901 6.76086 15.7715 6.34001 15.2551 6.34001C14.7387 6.34001 14.3201 6.76086 14.3201 7.28001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseIcon);
export default __webpack_public_path__ + "static/media/exercise_icon.f08b3e643fdc1f637d190e27cdffe740.svg";
export { ForwardRef as ReactComponent };